const memoryFields = {
    ValorNominal: "VN",
    ValorNominalAtualizado: "VNA",
    ValorJuros: "FinanceiroJuros",
    ValorIncorporacaoJuros: "IncorporacaoJuros",
    ValorAmortizacao: "FinanceiroAmortizacao",
    ValorAmortizacaoExtraordinaria: "FinanceiroAmortizacaoExtraordinaria",
    ValorPagamento: "Pagamento",
    CapitalizacaoJuros: "JurosCapitalizacao",
    ValorPremio: "Premio",
    TaxaLivreDeRisco: "TaxaRiskFree",
    ValorPresenteFluxo: "ValorMTMFluxo",
}

const mapMemory = (rows = []) => rows.map((row) => Object.entries(row)
    .filter(([field]) => field !== "LOGERRO")
    .reduce(
        (mapped, [field, value]) => ({...mapped, [memoryFields[field] ?? field]: value}),
        {},
    ))

export const mapTaxPreview = ({PUPAR, PUMTM, Indicadores, MemoriaCalculo}) => ({
    results: {
        puparCalculado: PUPAR.ValorCalculado,
        deltaPupar: PUPAR.DiferencaReferencia,
        variacaoPercentualPupar: PUPAR.VariacaoPercentual,
        pumtmCalculado: PUMTM.ValorCalculado,
        deltaPumtm: PUMTM.DiferencaReferencia,
        variacaoPercentualPumtm: PUMTM.VariacaoPercentual,
        percentualPupar: Indicadores.PercentualPUPAR,
        durationMacaulay: Indicadores.DurationMacaulay,
        durationModificada: Indicadores.DurationModificada,
    },
    memories: {
        pupar: mapMemory(MemoriaCalculo.PUPAR),
        pumtm: mapMemory(MemoriaCalculo.PUMTM),
        fatorCorrecao: mapMemory(MemoriaCalculo.FatorCorrecao),
    },
})
